module.exports = __webpack_public_path__ + "static/media/hashtags-screenshot-b-small.e3a80e83.png";